import EcoDesignEventsBus from 'eco-design-micro/EcoDesignEventsBus';
import './index.scss';
const LanguageSelection: React.FC = () => {
    return (
        <div
            className="header-language-selection"
            onClick={() => {
                EcoDesignEventsBus.emit('GlobalLocaleV1-region-open', 'top function');
            }}
        >
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.00016 14.457C11.6821 14.457 14.6668 11.4722 14.6668 7.79032C14.6668 4.10842 11.6821 1.12366 8.00016 1.12366C4.31826 1.12366 1.3335 4.10842 1.3335 7.79032C1.3335 11.4722 4.31826 14.457 8.00016 14.457Z"
                    stroke="white"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M1.3335 7.79032H14.6668" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.00016 14.457C9.47293 14.457 10.6668 11.4722 10.6668 7.79032C10.6668 4.10842 9.47293 1.12366 8.00016 1.12366C6.5274 1.12366 5.3335 4.10842 5.3335 7.79032C5.3335 11.4722 6.5274 14.457 8.00016 14.457Z"
                    stroke="white"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M3.28564 3.17053C4.49207 4.37697 6.15874 5.12317 7.99967 5.12317C9.84064 5.12317 11.5073 4.37697 12.7137 3.17053"
                    stroke="white"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12.7137 12.4097C11.5073 11.2032 9.84064 10.457 7.99967 10.457C6.15874 10.457 4.49207 11.2032 3.28564 12.4097"
                    stroke="white"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
            <span>English</span>
        </div>
    );
};

export default LanguageSelection;
